import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { Typography } from 'src/app/components/Elements/Typography';
import type { EscriptProps, OptimisticPendingTransfer } from 'src/app/types';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { EscriptCount, EscriptItem, MedicationHeader, MedicationItem, MedicationLabel } from '../styles';

interface StyledMedicationListProps {
  escriptCounts: EscriptProps[] | undefined;
  hideMedicationHeader?: boolean;
  medications?: OptimisticPendingTransfer[];
}

export const StyledMedicationList = ({
  escriptCounts,
  hideMedicationHeader = false,
  medications,
}: StyledMedicationListProps) => {
  return (
    <>
      {!hideMedicationHeader && <MedicationHeader>Your medications</MedicationHeader>}
      {(medications || []).map((medication, idx) => (
        <MedicationItem key={`${medication}-${idx}`}>
          <CapsuleIcon width={24} height={24} block iconString={CAPSULE_ICON_STRINGS.pill_bottle} />
          <MedicationLabel>{medication.name}</MedicationLabel>
        </MedicationItem>
      ))}
      {(escriptCounts || []).map(item => {
        const name = `${item.provider.firstName} ${item.provider.lastName}`;
        return (
          <EscriptItem key={item.providerId}>
            <Typography variant="body">{name}</Typography>
            <EscriptCount>
              <MedicationLabel>{item.count}</MedicationLabel>
              <CapsuleIcon width={24} height={24} block iconString={CAPSULE_ICON_STRINGS.pill_bottle} />
            </EscriptCount>
          </EscriptItem>
        );
      })}
    </>
  );
};
